// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ai-review-suggestions ol li:before{content:none}.ai-review-suggestions ol li{list-style-type:decimal;margin-bottom:0}", ""]);
// Exports
module.exports = exports;
